import React from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperProps } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import "swiper/css";
import "./Carousel.scss";

export type CarouselProps = {
  heading: string;
  moreText: string;
  moreLink: string;
  specificClass: string;
  children: React.ReactNode;
};

export function Carousel({ heading, moreText, moreLink, specificClass, children }: CarouselProps) {
  const swiperSettingsProps: SwiperProps = {
    modules: [Navigation, Pagination],
    navigation: {
      nextEl: `.${specificClass}-next`,
      prevEl: `.${specificClass}-prev`,
    },
    pagination: { clickable: true, dynamicBullets: true },
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    breakpoints: {
      1100: {
        spaceBetween: 20,
        slidesPerView: 3,
        slidesPerGroup: 3,
      },
      768: {
        spaceBetween: 10,
        slidesPerView: 2,
        slidesPerGroup: 2,
      },
    },
  };

  return (
    <div className="carousel">
      <div className="carousel__heading">
        <h2>{heading}</h2>
        <Link to={moreLink}>
          <Button variant="text">
            {moreText} <ButtonArrow />
          </Button>
        </Link>
      </div>

      <div className="carousel__cards">
        <Swiper {...swiperSettingsProps}>{children}</Swiper>
        <div className={`swiper-button-next ${specificClass}-next`}>
          <ButtonArrow />
        </div>
        <div className={`swiper-button-prev ${specificClass}-prev`}>
          <ButtonArrow />
        </div>
      </div>
    </div>
  );
}
